<template>
	<div id="app" class="auth-page">
		<div class="auth-card">
			<div class="auth-badge"><i class="fas fa-lock"></i></div>
			<h1 class="auth-title">Renouvellement du mot de passe</h1>
			<p class="auth-subtitle">Choisissez un nouveau mot de passe sécurisé</p>

			<form @submit="onSubmit">
				<div class="input_container">
					<ul>
						<li v-bind:class="{ is_valid: contains_eight_characters }">
							8 caractères
						</li>
						<li v-bind:class="{ is_valid: contains_number }">
							Contient un chiffre
						</li>
						<li v-bind:class="{ is_valid: contains_uppercase }">
							Contient une majuscule
						</li>
						<li v-bind:class="{ is_valid: contains_special_character }">
							Contient un caractère spécial
						</li>
					</ul>

					<div
						class="checkmark_container"
						v-bind:class="{ show_checkmark: valid_password }">
						<svg width="50%" height="50%" viewBox="0 0 140 100">
							<path
								class="checkmark"
								v-bind:class="{ checked: valid_password }"
								d="M10,50 l25,40 l95,-70" />
						</svg>
					</div>

					<div class="auth-field" style="margin-bottom: 0;">
						<div style="position: relative; display: inline-block; width: 100%;">
							<input
								class="auth-input form-control"
								:type="showPassword ? 'text' : 'password'"
								@input="checkPassword"
								v-model="password"
								autocomplete="off"
								placeholder="Nouveau mot de passe"
								style="width: 100%; padding-right: 40px;" />
							<button
								type="button"
								@click="showPassword = !showPassword"
								style="position: absolute; right: 5px; top: 50%; transform: translateY(-50%); border: none; background: transparent; cursor: pointer; color: #6b7280;">
								<i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
							</button>
						</div>
					</div>
					<input type="hidden" v-model="token" />

					<div>
						<b-button
							v-if="valid_password"
							type="submit"
							class="auth-submit"
							variant="primary"
							>Valider</b-button
						>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	import password from "../services/password.js";

	export default {
		name: "password",
		data() {
			return {
				token: 0,
				password: null,
				password_length: 0,
				contains_eight_characters: false,
				contains_number: false,
				contains_uppercase: false,
				contains_special_character: false,
				valid_password: false,
				showPassword: false,
			};
		},
		mounted() {
			this.token = this.$route.params.id;
		},
		methods: {
			onSubmit(evt) {
				evt.preventDefault();
				password.password(this.password, this.token).then((res) => {
					this.$router.push({ name: "login" });
				});
			},
			checkPassword() {
				this.password_length = this.password.length;
				const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

				if (this.password_length > 8) {
					this.contains_eight_characters = true;
				} else {
					this.contains_eight_characters = false;
				}

				this.contains_number = /\d/.test(this.password);
				this.contains_uppercase = /[A-Z]/.test(this.password);
				this.contains_special_character = format.test(this.password);

				if (
					this.contains_eight_characters === true &&
					this.contains_special_character === true &&
					this.contains_uppercase === true &&
					this.contains_number === true
				) {
					this.valid_password = true;
				} else {
					this.valid_password = false;
				}
			},
		},
	};
</script>

<style scoped>
	html {
		box-sizing: border-box;
	}

	*,
	*:before,
	*:after {
		box-sizing: inherit;
	}

	ul {
		padding-left: 20px;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		margin-bottom: 20px;
	}

	li {
		margin-bottom: 8px;
		color: #525f7f;
		font-size: 0.8rem;
		position: relative;
	}

	li:before {
		content: "";
		width: 0%;
		height: 2px;
		background: #6366f1;
		position: absolute;
		left: 0;
		top: 50%;
		display: block;
		transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
	}

	/* Password Input --------- */

	.input_container {
		position: relative;
	}

	/* Checkmark & Strikethrough --------- */

	.is_valid {
		color: rgba(136, 152, 170, 0.8);
	}
	.is_valid:before {
		width: 100%;
	}

	.checkmark_container {
		border-radius: 50%;
		position: absolute;
		top: -15px;
		right: -15px;
		background: #6366f1;
		width: 44px;
		height: 44px;
		visibility: hidden;
		opacity: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		transition: opacity 0.4s ease;
	}

	.show_checkmark {
		visibility: visible;
		opacity: 1;
	}

	.checkmark {
		width: 100%;
		height: 100%;
		fill: none;
		stroke: white;
		stroke-width: 15;
		stroke-linecap: round;
		stroke-dasharray: 180;
		stroke-dashoffset: 180;
	}

	.checked {
		animation: draw 0.5s ease forwards;
	}

	@keyframes draw {
		to {
			stroke-dashoffset: 0;
		}
	}
</style>
